import { EventCalendar } from './EventCalendar.js'

//lets start here
const selector_calender = document.body.querySelectorAll('.o-eventcalendar__outer')
const selector_list = document.body.querySelectorAll('.o-eventcalendar__list')
if (selector_calender[0] && selector_list[0]) {
  new EventCalendar(selector_calender[0], selector_list[0])
}

window.addEventListener("breakpointchanged", function(e){

}, false);